import React from "react";
import PropTypes from "prop-types";
import { Tab, Tabs } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import HistoryIcon from "@material-ui/icons/History";
import InfoIcon from "@material-ui/icons/Info";
import injectSheet from "react-jss";

import { Flex } from "../../../../_common";

const style = () => ({
  tabRootAtividadeEmMassa: {
    minWidth: "220px",
  },
  tabRootAtividadeIndividual: {
    minWidth: "150px",
  },
});

function AbasDrawer({ active, setActive, isAtividadeEmMassa, classes }) {
  const getColorIcon = tabValue => ({ color: active === tabValue ? "#F5845E" : "#0000008A" });
  const getClass = () => (isAtividadeEmMassa ? classes.tabRootAtividadeEmMassa : classes.tabRootAtividadeIndividual);

  return (
    <>
      <Flex center>
        <Tabs value={active} onChange={(e, v) => setActive(v)} variant="fullWidth">
          <Tab
            id="tab-detalhe-lead-atividade"
            value="detalhe"
            icon={<PersonIcon style={getColorIcon("detalhe")} />}
            classes={{
              root: getClass(),
            }}
          />
          {!isAtividadeEmMassa && (
            <Tab
              id="tab-timeline-lead-atividade"
              value="timeline"
              icon={<HistoryIcon style={getColorIcon("timeline")} />}
              classes={{
                root: getClass(),
              }}
            />
          )}
          <Tab
            id="tab-observacoes-lead-atividade"
            value="observacoes"
            icon={<InfoIcon style={getColorIcon("observacoes")} />}
            classes={{
              root: getClass(),
            }}
          />
        </Tabs>
      </Flex>
    </>
  );
}

AbasDrawer.propTypes = {
  active: PropTypes.bool,
  setActive: PropTypes.func,
  isAtividadeEmMassa: PropTypes.bool,
};

export default injectSheet(style)(AbasDrawer);
